import React, { useState, useEffect } from 'react';
import { DateRangePicker, DateRange } from 'react-date-range';
import Popover from '@material-ui/core/Popover';
import locale from 'date-fns/locale/fr/index.js';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Button from '../Button';
import { styles } from './DateRangePicker.styles';
import { mainColor } from '../../constants/theme';
import {
  parseDate,
  defaultStaticRanges,
  defaultInputRanges,
  handleSelectDate,
  onClose,
  onClick
} from './DateRangePicker.services';
import { getInitialDateRange } from '../../utils/suitableDate';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css';

interface DateRange {
  startDate: Date;
  endDate: Date;
  key: string;
}

interface CustomDateRangePickerProps {
  className?: string;
  classes?: any;
  dateRange: DateRange;
  disabled?: boolean;
  deepLinkCreationDate?: Date;
  onSelectDate: (dateRange: DateRange) => void;
  minDate?: Date;
  maxDate?: Date
}


const CustomDateRangePicker: React.FC<CustomDateRangePickerProps> = ({
  className,
  classes,
  dateRange,
  disabled = false,
  deepLinkCreationDate,
  onSelectDate,
  minDate,
  maxDate
}) => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [width, setWidth] = useState(window.innerWidth);
  const [selectedDateRange, setSelectedDateRange] = useState(getInitialDateRange());
  const [isSelectingRange, setIsSelectingRange] = useState(false);
  const staticRanges = defaultStaticRanges(deepLinkCreationDate);
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  return (
    <div className={className}>
      <Button
        color="secondary"
        outlined
        className="btn-xs-block"
        onClick={(event) => onClick(event, setAnchorEl, setOpen, open)}
        disabled={disabled}
      >
        <div className="row ml-0 mr-0 justify-content-center">
          {parseDate(dateRange.startDate, dateRange.endDate, deepLinkCreationDate)}
          <ArrowDropDownIcon className={classes?.arrowIcon} />
        </div>
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => onClose(setOpen)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        {width > 768 ? (
          <DateRangePicker
            minDate={minDate || moment().subtract(24, 'months').toDate()}
            staticRanges={defaultStaticRanges(deepLinkCreationDate)}
            inputRanges={defaultInputRanges}
            locale={locale}
            ranges={[selectedDateRange]}
            onChange={(ranges) => handleSelectDate(ranges, onSelectDate, setOpen, setSelectedDateRange, isSelectingRange, setIsSelectingRange, staticRanges)}
            rangeColors={[mainColor.secondaryColor]}
            color={mainColor.secondaryColor}
            maxDate={maxDate || moment(maxDate).toDate()}
          />
        ) : (
          <DateRange
            minDate={minDate || moment().subtract(6, 'months').toDate()}
            staticRanges={defaultStaticRanges(deepLinkCreationDate)}
            locale={locale}
            ranges={[selectedDateRange]}
            onChange={(ranges) => handleSelectDate(ranges, onSelectDate, setOpen, setSelectedDateRange, isSelectingRange, setIsSelectingRange, staticRanges)}
            rangeColors={[mainColor.secondaryColor]}
            color={mainColor.secondaryColor}
            maxDate={maxDate || moment(maxDate).toDate()}
          />
        )}
      </Popover>
    </div>
  );
};

export default withStyles(styles)(CustomDateRangePicker);
